import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { Breadcrumbs, useQueryGetCourseWithUnits } from "@examspark/common-app";
import { subjectMeta } from "@examspark/common-meta";
import { RouterLink, VSpace } from "@examspark/common-ui";
import { YagDataSource } from "@examspark/customer/tcmpc";

import ClassroomPlannerYag from "../../components/classroom/planners/ClassroomPlannerYag";
import PageHead from "../../components/common/PageHead";
import PageTitle from "../../components/common/PageTitle";

export const YearAtAGlanceRoute = () => {
  const params = useParams<{
    id: string;
  }>();
  const { data: course } = useQueryGetCourseWithUnits(params.id);

  const subject = course?.subject?.[0] as keyof typeof subjectMeta;
  const [dataSource, setDataSource] = useState<YagDataSource>();

  return (
    <>
      <VSpace size="3rem">
        <PageHead>
          <Breadcrumbs
            items={[
              ...Breadcrumbs.Dashboard(),
              <RouterLink key="courses" to="/browse">
                Courses
              </RouterLink>,
              subject ? (
                <RouterLink key="subject" to="/browse">
                  {subjectMeta[subject]?.label}
                </RouterLink>
              ) : null,
              <RouterLink key="course" to={`/course/${params.id}`}>
                {course?.name}
              </RouterLink>,
            ]}
          />
          <PageTitle subtitle="Year at a Glance">
            {course?.name ? course?.name : "Loading Course..."}
          </PageTitle>
        </PageHead>
        {course && (
          <ClassroomPlannerYag
            course={course}
            value={dataSource}
            onChange={setDataSource}
            linkContext={{
              type: "course",
              course,
            }}
          />
        )}
      </VSpace>
    </>
  );
};
